import React, {useState, useEffect} from "react";
import {injectIntl} from "react-intl";
import {useSelector} from "react-redux";
import { fetchTenantDashboard } from "../Reports/ReportsCrud"
import MetabaseEmbedCard from "../Reports/MetabaseEmbedCard";

function ClientDashboardPage(props) {
    
    const [dashboard, setDashboard] = useState(null)
    const [isDashboardFound, setIsDashboardFound] = useState(false);

    const {accessToken} = useSelector(
        ({auth}) => ({
            accessToken: auth.authToken,
        }));

    useEffect(() => {

        fetchTenantDashboard(accessToken).then(response => {
            const dashboardData = response.data.data
            
            if(dashboardData){
                setDashboard(dashboardData)
                setIsDashboardFound(true)
            }
      
          }).catch(error => console.log(error))
    }, [accessToken])

    return (
        <>
            { isDashboardFound && dashboard ? 
                <MetabaseEmbedCard
                    reportConfig={dashboard}
                    accessToken={accessToken}
                    isDashboard={true}
                />
                :
                null
            }
            
        </>
       
    );
}

export default injectIntl(ClientDashboardPage);
